import { render, staticRenderFns } from "./AltPhoneField.vue?vue&type=template&id=48c56fe2&"
import script from "./AltPhoneField.vue?vue&type=script&lang=js&"
export * from "./AltPhoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports